/*************************************************/
/* VIDEO                                         */
/*************************************************/

export function video() {
    let $video;

    const init = function () {
        $video = $(".video-item__player");


        const insertYoutubeApiScriptTag = function () {
            if (!youtubeLoaded) {
                var tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            }

        }

        // Video
        if ($video.length) {
            $video.click(function () {
                const that = this;
                const localVideo = that.querySelector('.video-item__video')

                const playerId = that.dataset.playerid;
                const videoId = that.dataset.videoid;
                let playerName = `_${playerId}`;
                const isYoutubeVideo = (typeof (videoId) != 'undefined') && localVideo == null;

                if (!isYoutubeVideo) {
                    that.querySelector('video').play();
                    that.classList.add("video-item__player--playing");

                } else if (isYoutubeVideo) {
                    if (!Cookiebot.consent.marketing) {
                        console.log("Cookie not set");
                        CookieConsent.renew();
                        return false;
                    } else {
                    insertYoutubeApiScriptTag();
                    var iterations = 0;

                    var loadViewTimer = setInterval(function () {
                        if (youtubeLoaded) {
                            clearInterval(loadViewTimer);
                            playerName = new YT.Player(playerId,
                                {
                                    height: "100%",
                                    width: "100%",
                                    videoId: videoId,
                                    host: "https://www.youtube-nocookie.com",
                                    events: {
                                        "onReady": onPlayerReady,
                                        "onStateChange": onPlayerStateChange
                                    },
                                    playerVars: {
                                        showinfo: 0,
                                        rel: 0
                                    }
                                });
                        } else {
                            iterations++;
                        }

                        //Lets try for 10 seconds
                        if (iterations === 100) {
                            clearInterval(loadViewTimer);
                        }

                    }, 100);

                    function onPlayerReady(event) {
                        event.target.playVideo();
                        that.classList.add("video-item__player--playing");
                    }

                    function onPlayerStateChange(event) {
                        if (event.data === YT.PlayerState.ENDED) {
                            playerName.destroy();

                            that.classList.remove("video-item__player--playing");
                        }
                    }
                }
                   }
            });
        }
    };

    init();
}